<template>
  <div>

<!--    <YourSynchronicityExtension/>-->

  </div>

</template>

<script>

import YourSynchronicityExtension from "@/components/YourSynchronicityExtension";

export default {
  name: 'Home',
  components: {
    YourSynchronicityExtension
  },
  methods: {},
  created() {
    console.log('this is home')
    this.$cookie.set("now", "123", "expiring time")
  }
}
</script>
